class SponsorsCarousel {
  constructor() {
    this.initCarousel();
  }

  initCarousel() {
    window.addEventListener("DOMContentLoaded", () => {
      // Wait for both Splide and the AutoScroll extension to load
      const interval = setInterval(() => {
        if (
          typeof Splide !== "undefined" &&
          typeof window.splide !== "undefined" &&
          window.splide.Extensions.AutoScroll
        ) {
          clearInterval(interval);
          this.setupCarousel();
        } else {
          console.warn("Waiting for Splide auto-scroll extension...");
        }
      }, 100);
    });
  }

  setupCarousel() {
    const sponsorsSlider = new Splide(".sponsors-splide", {
      type: "loop",
      autoWidth: true,
      gap: 60,
      pagination: false,
      arrows: false,
      clones: 10,
      autoScroll: {
        speed: 2,
        pauseOnHover: false,
      },
    });

    // Explicitly pass the AutoScroll extension
    sponsorsSlider.mount({ AutoScroll: window.splide.Extensions.AutoScroll });
  }
}

export default SponsorsCarousel;
